module.exports = __webpack_public_path__ + "img/photo03.645d34ee.jpg";